/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.userUnsubscribe

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import okio.FileSystem
import features.userUnsubscribe.internal.UserUnsubscribeUseCase
import features.userUnsubscribe.internal.UserUnsubscribeUseCase.Params
import kangaroorewards.appsdk.core.io.EmptyResponse


typealias UserUnsubscribeState = CFlow<UserUnsubscribeUseCaseResult?>

typealias UserUnsubscribeUseCaseResult = Result<EmptyResponse>

fun UserUnsubscribeUseCaseResult.serializeUserUnsubscribeApiResult(): SerializedResult<String> {
    return this.toJsonResult<EmptyResponse>()
}

/**
 * Serializes [UserUnsubscribeState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun UserUnsubscribeState.serializeUserUnsubscribeState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<EmptyResponse>()
    }.asCFlow()
}

/**
 * Unsubscribe from marketing material  [Api] class
 */
class UserUnsubscribeApi : Api() {

    val userUnsubscribeState: UserUnsubscribeState
        get() = _userUnsubscribeState.asCFlow()

    companion object {
        private val _userUnsubscribeState: MutableStateFlow<UserUnsubscribeUseCaseResult> = MutableStateFlow(Idle())
    }

    private val userUnsubscribeUseCase = UserUnsubscribeUseCase()

    /**
     * Unsubscribe from marketing material 
     */
    suspend fun unsubscribe(
        overrideHeaders: Map<String, String>? = null,
        campaignId: String,
        token: String
    ): Result<EmptyResponse> {
        /* set state to Loading as soon as function is called */
        _userUnsubscribeState.value = Loading()
        val result = this.userUnsubscribeUseCase(
            Params(
                overrideHeaders = overrideHeaders,
                campaignId = campaignId,
                token = token
            )
        ) { result ->
            _userUnsubscribeState.value = result
            return@userUnsubscribeUseCase result
        }
        return result
    }

}
